import React, { useContext } from 'react';
import { BaseContext } from '../contexts/baseContext';

export default function NavigationMobile() {
  let {navigateTo, setInterfaceType} = useContext(BaseContext);

  return (
    <div className="section-contacts-footer">
      <i className="bi bi-person" onClick={() => navigateTo("profil")}></i>
      <i className="bi bi-chat-square icon-active" onClick={() => navigateTo("contacts")}></i>
      <i className="bi bi-person-plus" onClick={() => { setInterfaceType("researchContact"); navigateTo("add-contact"); }}></i>
      <i className="bi bi-gear"></i>
    </div>
  );
}
